export const SERVER_URL = "https://do-calculate.com/api";

export const financialCalculators_Fr = [
  // EXISTING CALCULATORS
  {
    name: "Calculatrice du ratio Prix/Bénéfices (P/E)",
    link: "/calculator/fr/pe-ratio/",
    description:
      "Calculez rapidement le ratio Prix/Benefices (P/E) a partir du cours de l action et du benefice par action pour evaluer une valorisation boursiere.",
    showMain: true,
  },
  {
    name: "Calculatrice de l'impact de l'inflation",
    link: "/calculator/fr/inflation/",
    description:
      "Mesurez la perte de pouvoir d achat d un montant sur plusieurs annees et estimez la somme necessaire pour conserver la meme valeur reelle.",
    showMain: true,
  },
  {
    name: "Calculatrice Google AdSense",
    link: "/calculator/fr/google-adsense/",
    description:
      "Estimez vos revenus Google AdSense selon votre trafic, votre CTR et votre CPC moyen pour mieux projeter la monetisation de votre site.",
    showMain: true,
  },
  {
    name: "Calculatrice TVA",
    link: "/calculator/fr/vat/",
    description:
      "Calculez un montant HT, TTC ou TVA en quelques secondes pour vos factures, devis, achats et ventes avec un taux personnalise.",
    showMain: true,
  },

  {
    name: "Calculatrice de commission",
    link: "/calculator/fr/commission-calculator/",
    description:
      "Calculez une commission de vente a partir du montant vendu et du pourcentage applique pour estimer le gain brut.",
    showMain: true,
  },
  {
    name: "Calculatrice de salaire journalier",
    link: "/calculator/fr/daily-salary-calculator/",
    description:
      "Convertissez un salaire mensuel ou annuel en salaire journalier pour comparer des offres ou estimer une mission.",
    showMain: true,
  },
  {
    name: "Calculatrice de remise",
    link: "/calculator/fr/discount-calculator/",
    description:
      "Calculez un prix apres remise, le montant economise et le pourcentage de reduction sur un produit ou un service.",
    showMain: true,
  },
  {
    name: "Calculatrice du coût du carburant",
    link: "/calculator/fr/fuel-cost-calculator/",
    description:
      "Estimez le cout du carburant d un trajet selon la distance, la consommation du vehicule et le prix du litre ou du gallon.",
    showMain: true,
  },
  {
    name: "Calculatrice de salaire horaire",
    link: "/calculator/fr/hourly-salary-calculator/",
    description:
      "Transformez un salaire annuel ou mensuel en salaire horaire pour comparer une remuneration et evaluer votre temps de travail.",
    showMain: true,
  },
  {
    name: "Calculatrice de ventes nettes",
    link: "/calculator/fr/net-sales-calculator/",
    description:
      "Calculez les ventes nettes a partir des ventes brutes en deduisant les retours et les remises accordees aux clients.",
    showMain: true,
  },
  {
    name: "Calculatrice de frais PayPal",
    link: "/calculator/fr/paypal-fee/",
    description:
      "Calculez les frais PayPal de n importe quelle transaction et connaissez le montant net recu ou a envoyer.",
    showMain: true,
  },
  {
    name: "Calculatrice de marge bénéficiaire",
    link: "/calculator/fr/profit-margin-calculator/",
    description:
      "Calculez la marge brute, operationnelle et nette de votre activite pour analyser la rentabilite avec precision.",
    showMain: true,
  },
  {
    name: "Calculatrice ROI",
    link: "/calculator/fr/roi-calculator/",
    description:
      "Calculez le retour sur investissement de tout projet ou achat avec option de ROI annualise sur plusieurs annees.",
    showMain: true,
  },
  {
    name: "Calculatrice d'augmentation de salaire",
    link: "/calculator/fr/salary-bonus-calculator/",
    description:
      "Calculez la valeur de l augmentation de salaire que vous obtiendrez en fonction d un pourcentage de votre salaire de base.",
    showMain: true,
  },
];
